<template>
  <!-- Add Customer -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div
              class="modal-header border-0 custom-modal-header justify-content-between"
            >
              <div class="page-title">
                <h4>Ajouter un nouveau Tier</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.nom"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.prenom"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Civilité</label>
                      <vue-select
                        :options="Civilite"
                        id="choosecus"
                        placeholder="Choose"
                        v-model="form.civilite"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">CIN</label>
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="text"
                        v-model="form.cin"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.adresse"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': clientEmailError }"
                        v-model="form.email"
                        @blur="validateClientEmail('create')"
                        required
                      />
                      <div v-if="clientEmailError" class="invalid-feedback d-block">
                        {{ clientEmailError }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Télephone</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.telephone"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Pays</label>
                      <vue-select
                        :options="Countries"
                        id="choosecuss"
                        placeholder="Choisir"
                        v-model="form.pays"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-if="villesData && villesData.length > 0">
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <vue-select
                        :options="villesData"
                        id="sellingtypess"
                        placeholder="Choisir"
                        v-model="form.ville"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-else>
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.ville"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type</label>
                      <vue-select
                        :options="Types"
                        id="choosecusss"
                        placeholder="Choisir"
                        v-model="form.type"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type Client</label>
                      <vue-select
                        :options="ClientsType"
                        id="choosecu"
                        placeholder="Choisir"
                        v-model="form.type_client"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">Nom du Sociète</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.nom_societe"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">ICE</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.ice"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">RC</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.rc"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">TP</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.tp"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">Identifiant Fiscal</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.identifiant_fiscal"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Plafond du crédit</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        v-model="form.plafond_credit"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Délai de Paiement</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        v-model="form.delai_paiement"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label"
                        >Informations Complementaires</label
                      >
                      <textarea
                        class="form-control mb-1"
                        v-model="form.informations_complementaires"
                        required
                      ></textarea>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Customer -->

  <!-- Edit Customer -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div
              class="modal-header border-0 custom-modal-header justify-content-between"
            >
              <div class="page-title">
                <h4>Modifier un Client</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm1">
                <div class="row">
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.nom"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.prenom"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Civilité</label>
                      <vue-select
                        :options="Civilite"
                        id="choosecuaa"
                        placeholder="Choose"
                        v-model="form1.civilite"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">CIN</label>
                      <input
                        class="form-control form-control-lg group_formcontrol"
                        type="text"
                        v-model="form1.cin"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.adresse"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': clientEmailErrorEdit }"
                        v-model="form1.email"
                        @blur="validateClientEmail('edit')"
                        required
                      />
                      <div
                        v-if="clientEmailErrorEdit"
                        class="invalid-feedback d-block"
                      >
                        {{ clientEmailErrorEdit }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Télephone</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.telephone"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Pays</label>
                      <vue-select
                        :options="Countries"
                        id="choosecusssasas"
                        placeholder="Choisir"
                        v-model="form1.pays"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-if="villesData && villesData.length > 0">
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <vue-select
                        :options="villesData"
                        id="sellingtypessdedede"
                        placeholder="Choisir"
                        v-model="form1.ville"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-else>
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.ville"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type</label>
                      <vue-select
                        :options="Types"
                        id="choosecusssfrfrfg"
                        placeholder="Choisir"
                        v-model="form1.type"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type Client</label>
                      <vue-select
                        :options="ClientsType"
                        id="choosecutytyy"
                        placeholder="Choisir"
                        v-model="form1.type_client"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form1.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">Nom du Sociète</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.nom_societe"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form1.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">ICE</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.ice"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form1.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">RC</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.rc"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form1.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">TP</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.tp"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-6 pe-0"
                    v-if="form1.type === 'Professionnel'"
                  >
                    <div class="mb-3">
                      <label class="form-label">Identifiant Fiscal</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.identifiant_fiscal"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Plafond du crédit</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        v-model="form1.plafond_credit"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Délai de Paiement</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        v-model="form1.delai_paiement"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label"
                        >Informations Complementaires</label
                      >
                      <textarea
                        class="form-control mb-1"
                        v-model="form1.informations_complementaires"
                        required
                      ></textarea>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Customer -->
</template>
<script>
import {
  createClient,
  updateClient,
  checkClientEmail,
} from "@/services/clientsService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import countriesJSON from "@/assets/json/countries.json";
import citiesJSON from "@/assets/json/cities.json";
import { toast } from "vue3-toastify";

const categories = [
  "Électronique",
  "Mode",
  "Maison & Cuisine",
  "Livres",
  "Sports & Plein air",
  "Jouets & Jeux",
  "Beauté & Soins personnels",
  "Santé & Bien-être",
  "Automobile",
  "Fournitures pour animaux",
  "Informatique",
  "Bricolage & Outils",
  "Jardin & Extérieur",
  "Instruments de musique",
  "Films & Séries",
  "Jeux vidéo",
  "Articles de bureau",
  "Bagagerie & Voyage",
  "Alimentation & Boissons",
  "Art & Artisanat",
];
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        adresse: "",
        informations_complementaires: "",
        ville: "",
        pays: "Maroc",
        civilite: "",
        nom: "",
        prenom: "",
        cin: "",
        email: "",
        telephone: "",
        type: "",
        type_client: "",
        user_id: null,
        plafond_credit: null,
        delai_paiement: null,
        societe_id: null,
        nom_societe: "",
        ice: "",
        rc: "",
        tp: "",
        identifiant_fiscal: "",
      },
      form1: {
        id: null,
        adresse: "",
        informations_complementaires: "",
        ville: "",
        pays: "Maroc",
        civilite: "",
        nom: "",
        prenom: "",
        cin: "",
        email: "",
        telephone: "",
        type: "",
        type_client: "",
        user_id: null,
        plafond_credit: null,
        delai_paiement: null,
        societe_id: null,
        nom_societe: "",
        ice: "",
        rc: "",
        tp: "",
        identifiant_fiscal: "",
      },
      clientEmailError: "",
      clientEmailErrorEdit: "",
      clientEmailCheckTimer: null,
      clientEmailCheckTimerEdit: null,
      Countries: [
        "Afghanistan",
        "Afrique du Sud",
        "Albanie",
        "Algérie",
        "Allemagne",
        "Andorre",
        "Angola",
        "Antigua-et-Barbuda",
        "Arabie saoudite",
        "Argentine",
        "Arménie",
        "Australie",
        "Autriche",
        "Azerbaïdjan",
        "Bahamas",
        "Bahreïn",
        "Bangladesh",
        "Barbade",
        "Belgique",
        "Belize",
        "Bénin",
        "Bhoutan",
        "Biélorussie",
        "Birmanie (Myanmar)",
        "Bolivie",
        "Bosnie-Herzégovine",
        "Botswana",
        "Brésil",
        "Brunei",
        "Bulgarie",
        "Burkina Faso",
        "Burundi",
        "Cambodge",
        "Cameroun",
        "Canada",
        "Cap-Vert",
        "Chili",
        "Chine",
        "Chypre",
        "Colombie",
        "Comores",
        "Congo (Brazzaville)",
        "Congo (RDC)",
        "Corée du Nord",
        "Corée du Sud",
        "Costa Rica",
        "Côte d'Ivoire",
        "Croatie",
        "Cuba",
        "Danemark",
        "Djibouti",
        "Dominique",
        "Égypte",
        "Émirats arabes unis",
        "Équateur",
        "Érythrée",
        "Espagne",
        "Estonie",
        "Eswatini",
        "États-Unis",
        "Éthiopie",
        "Fidji",
        "Finlande",
        "France",
        "Gabon",
        "Gambie",
        "Géorgie",
        "Ghana",
        "Grèce",
        "Grenade",
        "Guatemala",
        "Guinée",
        "Guinée équatoriale",
        "Guinée-Bissau",
        "Guyana",
        "Haïti",
        "Honduras",
        "Hongrie",
        "Inde",
        "Indonésie",
        "Iran",
        "Irak",
        "Irlande",
        "Islande",
        "Italie",
        "Jamaïque",
        "Japon",
        "Jordanie",
        "Kazakhstan",
        "Kenya",
        "Kirghizistan",
        "Kiribati",
        "Koweït",
        "Laos",
        "Lesotho",
        "Lettonie",
        "Liban",
        "Libéria",
        "Libye",
        "Liechtenstein",
        "Lituanie",
        "Luxembourg",
        "Macédoine du Nord",
        "Madagascar",
        "Malaisie",
        "Malawi",
        "Maldives",
        "Mali",
        "Malte",
        "Maroc",
        "Îles Marshall",
        "Maurice",
        "Mauritanie",
        "Mexique",
        "Micronésie",
        "Moldavie",
        "Monaco",
        "Mongolie",
        "Monténégro",
        "Mozambique",
        "Namibie",
        "Nauru",
        "Népal",
        "Nicaragua",
        "Niger",
        "Nigéria",
        "Norvège",
        "Nouvelle-Zélande",
        "Oman",
        "Ouganda",
        "Ouzbékistan",
        "Pakistan",
        "Palaos",
        "Palestine",
        "Panama",
        "Papouasie-Nouvelle-Guinée",
        "Paraguay",
        "Pays-Bas",
        "Pérou",
        "Philippines",
        "Pologne",
        "Portugal",
        "Qatar",
        "Roumanie",
        "Royaume-Uni",
        "Russie",
        "Rwanda",
        "Saint-Kitts-et-Nevis",
        "Sainte-Lucie",
        "Saint-Marin",
        "Saint-Vincent-et-les-Grenadines",
        "Salvador",
        "Samoa",
        "Sao Tomé-et-Principe",
        "Sénégal",
        "Serbie",
        "Seychelles",
        "Sierra Leone",
        "Singapour",
        "Slovaquie",
        "Slovénie",
        "Somalie",
        "Soudan",
        "Soudan du Sud",
        "Sri Lanka",
        "Suède",
        "Suisse",
        "Suriname",
        "Syrie",
        "Tadjikistan",
        "Tanzanie",
        "Tchad",
        "République tchèque",
        "Thaïlande",
        "Timor oriental",
        "Togo",
        "Tonga",
        "Trinité-et-Tobago",
        "Tunisie",
        "Turkménistan",
        "Turquie",
        "Tuvalu",
        "Ukraine",
        "Uruguay",
        "Vanuatu",
        "Vatican",
        "Venezuela",
        "Viêt Nam",
        "Yémen",
        "Zambie",
        "Zimbabwe",
      ],
      ClientsType: ["FOURNISSEUR", "CLIENT", "PROSPECT"],
      Types: ["Particulié", "Professionnel"],
      Types1: ["INDIVIDUAL", "COMPANY"],
      Civilite: ["M", "MME"],
      ChooseCusOne: ["Varrel", "Varrel"],
      ChooseCityOne: ["Germany", "United State"],
      villesData: [],
      categories,
    };
  },
  methods: {
    scheduleClientEmailCheck(mode = "create") {
      const timerKey = mode === "create" ? "clientEmailCheckTimer" : "clientEmailCheckTimerEdit";
      const errorField = mode === "create" ? "clientEmailError" : "clientEmailErrorEdit";
      const email = mode === "create" ? this.form.email : this.form1.email;

      if (this[timerKey]) {
        clearTimeout(this[timerKey]);
        this[timerKey] = null;
      }

      if (!email) {
        this[errorField] = "";
        return;
      }

      this[timerKey] = setTimeout(() => {
        this.validateClientEmail(mode);
      }, 400);
    },
    async validateClientEmail(mode = "create") {
      const target = mode === "create" ? this.form : this.form1;
      const errorField = mode === "create" ? "clientEmailError" : "clientEmailErrorEdit";
      const email = (target.email || "").trim();
      const ignoreId = mode === "edit" ? this.form1.id : null;

      if (!email) {
        this[errorField] = "";
        return true;
      }

      try {
        const result = await checkClientEmail(email, ignoreId);
        const available = result?.data?.available ?? true;
        this[errorField] = available ? "" : "Cet email est déjà utilisé.";
        return available;
      } catch (error) {
        console.error(error);
        this[errorField] = "";
        return true;
      }
    },
    // Prefer FR translation when available, otherwise fall back to English name
    getCountryDisplayName(c) {
      if (!c) return "";
      const tr = c.translations || {};
      return tr.fr || tr["fr"] || c.name;
    },
    // Build country options from JSON
    buildCountriesOptions() {
      try {
        const list = (countriesJSON || []).map((c) => this.getCountryDisplayName(c));
        this.Countries = Array.from(new Set(list.filter(Boolean))).sort((a, b) =>
          a.localeCompare(b, "fr")
        );
        if (!this.form.pays && this.Countries.length) {
          this.form.pays = this.Countries.includes("Maroc")
            ? "Maroc"
            : this.Countries[0];
        }
      } catch (e) {
        // keep existing static list as fallback
      }
    },
    // Update cities list based on selected country name
    updateCitiesOptionsForPays(paysName) {
      if (!paysName) {
        this.villesData = [];
        return;
      }
      const country = (countriesJSON || []).find(
        (c) => this.getCountryDisplayName(c).toLowerCase() === paysName.toLowerCase()
      );
      if (!country) {
        this.villesData = [];
        return;
      }
      const id = country.id;
      const names = (citiesJSON || [])
        .filter((ct) => ct.country_id === id)
        .map((ct) => ct.name)
        .filter(Boolean);
      this.villesData = Array.from(new Set(names)).sort((a, b) =>
        a.localeCompare(b, "fr")
      );
    },
    // Extract a clear message from Axios/Laravel error responses
    getErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (!data) return (error && error.message) || "Une erreur est survenue.";
      if (typeof data === "string") return data;
      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstVal = data.errors[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) return firstVal[0];
        if (typeof firstVal === "string") return firstVal;
      }
      if (data.error) return data.error;
      if (data.message) return data.message;
      return "Une erreur est survenue.";
    },
    async submitForm() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        // Validation côté client en Français
        if (!this.form.pays) {
          return toast.error("Veuillez sélectionner un pays.");
        }
        if (this.villesData && this.villesData.length > 0 && !this.form.ville) {
          return toast.error("Veuillez sélectionner une ville.");
        }
        const emailAvailable = await this.validateClientEmail("create");
        if (!emailAvailable) {
          return toast.error(this.clientEmailError || "Cet email est déjà utilisé.");
        }
        const response = await createClient({
          adresse: this.form.adresse,
          informations_complementaires: this.form.informations_complementaires,
          ville: this.form.ville,
          pays: this.form.pays,
          civilite: this.form.civilite,
          nom: this.form.nom,
          prenom: this.form.prenom,
          cin: this.form.cin,
          email: this.form.email,
          telephone: this.form.telephone,
          type: this.form.type === "Particulié" ? "INDIVIDUAL" : "COMPANY",
          type_client: this.form.type_client,
          user_id: this.form.user_id,
          plafond_credit: this.form.plafond_credit,
          delai_paiement: this.form.delai_paiement,
          societe_id: this.form.societe_id,
          nom_societe: this.form.nom_societe,
          rc: this.form.rc,
          tp: this.form.tp,
          ice: this.form.ice,
          identifiant_fiscal: this.form.identifiant_fiscal,
        });
        this.$emit("client-added", response);
        this.clientEmailError = "";

        const modalElement = document.getElementById("add-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getErrorMessage(error));
      }
    },
    async submitForm1() {
      try {
        // Validation côté client en Français
        if (!this.form1.pays) {
          return toast.error("Veuillez sélectionner un pays.");
        }
        if (this.villesData && this.villesData.length > 0 && !this.form1.ville) {
          return toast.error("Veuillez sélectionner une ville.");
        }
        const emailAvailable = await this.validateClientEmail("edit");
        if (!emailAvailable) {
          return toast.error(this.clientEmailErrorEdit || "Cet email est déjà utilisé.");
        }
        const response = await updateClient(this.form1.id, {
          adresse: this.form1.adresse,
          informations_complementaires: this.form1.informations_complementaires,
          ville: this.form1.ville,
          pays: this.form1.pays,
          civilite: this.form1.civilite,
          nom: this.form1.nom,
          prenom: this.form1.prenom,
          cin: this.form1.cin,
          telephone: this.form1.telephone,
          type: this.form1.type === "Particulié" ? "INDIVIDUAL" : "COMPANY",
          type_client: this.form1.type_client,
          plafond_credit: this.form1.plafond_credit,
          delai_paiement: this.form1.delai_paiement,
          societe_id: this.form1.societe_id,
          nom_societe: this.form1.nom_societe,
          rc: this.form1.rc,
          tp: this.form1.tp,
          ice: this.form1.ice,
          identifiant_fiscal: this.form1.identifiant_fiscal,
        });
        this.$emit("client-updated", response);
        this.clientEmailErrorEdit = "";

        const modalElement = document.getElementById("edit-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getErrorMessage(error));
      }
    },
    capitalizeFirstLetter(str) {
      if (!str) return ""; // handle empty string
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
  mounted() {
    // Initialize countries and cities from JSON files
    this.buildCountriesOptions();
    this.updateCitiesOptionsForPays(this.form.pays);
    if (!this.form.ville && this.villesData && this.villesData.length > 0) {
      this.form.ville = this.villesData[0];
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.id = newData.id;
        this.form1.adresse = newData?.adresse || "";
        this.form1.informations_complementaires =
          newData?.informations_complementaires || "";
        this.form1.ville = this.capitalizeFirstLetter(newData?.ville) || "";
        this.form1.pays = this.capitalizeFirstLetter(newData?.pays) || "";
        this.form1.civilite = newData?.civilite || "";
        this.form1.nom = newData?.nom || "";
        this.form1.prenom = newData?.prenom || "";
        this.form1.cin = newData?.cin || "";
        this.form1.email = newData?.email || "";
        this.form1.telephone = newData?.telephone || "";
        this.form1.type =
          newData?.type === "INDIVIDUAL" ? "Particulié" : "Professionnel" || "";
        this.form1.type_client = newData?.type_client || "";
        this.form1.user_id = newData?.user_id || "";
        this.form1.plafond_credit = newData?.plafond_credit || "";
        this.form1.delai_paiement = newData?.delai_paiement || "";
        this.form1.societe_id = newData?.societe_id || "";
        this.form1.nom_societe = newData?.nom_societe || "";
        this.form1.ice = newData?.ice || "";
        this.form1.rc = newData?.rc || "";
        this.form1.tp = newData?.tp || "";
        this.form1.identifiant_fiscal = newData?.identifiant_fiscal || "";
        this.clientEmailErrorEdit = "";

        // Ensure edit modal cities are aligned with the loaded country
        if (this.form1.pays) {
          this.updateCitiesOptionsForPays(this.form1.pays);
        }
      },
    },
    // Update cities when selected country changes (add modal)
    "form.pays"(val) {
      this.updateCitiesOptionsForPays(val);
      // Default to the first city if available, otherwise clear
      this.form.ville = this.villesData && this.villesData.length > 0 ? this.villesData[0] : "";
    },
    // Update cities when selected country changes (edit modal)
    "form1.pays"(val) {
      this.updateCitiesOptionsForPays(val);
      // Default to the first city if available, otherwise clear
      this.form1.ville = this.villesData && this.villesData.length > 0 ? this.villesData[0] : "";
    },
    "form.email"(value) {
      if (!value) {
        this.clientEmailError = "";
      }
      this.scheduleClientEmailCheck("create");
    },
    "form1.email"(value) {
      if (!value) {
        this.clientEmailErrorEdit = "";
      }
      this.scheduleClientEmailCheck("edit");
    },
  },
  beforeUnmount() {
    if (this.clientEmailCheckTimer) {
      clearTimeout(this.clientEmailCheckTimer);
    }
    if (this.clientEmailCheckTimerEdit) {
      clearTimeout(this.clientEmailCheckTimerEdit);
    }
  },
};
</script>
